import { all, takeEvery, put, call } from 'redux-saga/effects';
import * as statisticsService from '../../services/statistics';
import actions from './actions';

export function* dashboard() {
  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadinshDashboard: true,
    },
  });

  const response = yield call(statisticsService.dashboard);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        dashboard: data.data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingDashboard: false,
    },
  })
}


export function* basicMembersBySport({ payload }) {
  const { countryId } = payload;
  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingBasicMembersBySport: true,
    },
  });

  const response = yield call(statisticsService.basicMembersBySport, countryId);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        basicMembersBySport: data.data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingBasicMembersBySport: false,
    },
  })
}

export function* basicRegistrationsByPlace({ payload }) {
  const { countryId } = payload;
  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingBasicRegistrationsByPlace: true,
    },
  });

  const response = yield call(statisticsService.basicRegistrationsByPlace, countryId);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        basicRegistrationsByPlace: data.data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingBasicRegistrationsByPlace: false,
    },
  })
}

export function* basicMembersWithoutConsentByPlace({ payload }) {
  const { countryId } = payload;
  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingBasicMembersWithoutConsentByPlace: true,
    },
  });

  const response = yield call(statisticsService.basicMembersWithoutConsentByPlace, countryId);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        basicMembersWithoutConsentByPlace: data.data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingBasicMembersWithoutConsentByPlace: false,
    },
  })
}

export function* registrationSportsByPlace({ payload }) {
  const { countryId, placeId } = payload;
  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingSportsByPlace: true
    },
  });

  const response = yield call(statisticsService.registrationSportsByPlace, countryId, placeId);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        sportsByPlace: data.data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingSportsByPlace: false
    },
  })
}

export function* registrationsByPlace({ payload }) {
  const { countryId, sorting, filter } = payload;

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingRegistrationsByPlace: true,
    },
  });

  const response = yield call(statisticsService.registrationsByPlace, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        registrationsByPlace: data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingRegistrationsByPlace: false,
    },
  })
}

export function* registrationsBySport({ payload }) {
  const { countryId, sorting, filter } = payload;

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingRegistrationsBySport: true,
    },
  });

  const response = yield call(statisticsService.registrationsBySport, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        registrationsBySport: data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingRegistrationsBySport: false,
    },
  })
}

export function* exportRegistrationsByPlace({ payload }) {
  const { countryId, sorting, filter, format, name } = payload;

  yield call(statisticsService.exportRegistrationsByPlace, countryId, sorting, filter, format, name);
}

export function* exportRegistrationsBySport({ payload }) {
  const { countryId, sorting, filter, format, name } = payload;

  yield call(statisticsService.exportRegistrationsBySport, countryId, sorting, filter, format, name);
}

export function* membersByPlace({ payload }) {
  const { countryId, sorting, filter } = payload;

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingMembersByPlace: true,
    },
  });

  const response = yield call(statisticsService.membersByPlace, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        membersByPlace: data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingMembersByPlace: false,
    },
  })
}

export function* membersBySport({ payload }) {
  const { countryId, sorting, filter } = payload;

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingMembersBySport: true,
    },
  });

  const response = yield call(statisticsService.membersBySport, countryId, sorting, filter);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'statistic/SET_STATE',
      payload: {
        membersBySport: data
      },
    })
  }

  yield put({
    type: 'statistic/SET_STATE',
    payload: {
      loadingMembersBySport: false,
    },
  })
}

export function* exportMembersByPlace({ payload }) {
  const { countryId, sorting, filter, format, name } = payload;

  yield call(statisticsService.exportMembersByPlace, countryId, sorting, filter, format, name);
}

export function* exportMembersBySport({ payload }) {
  const { countryId, sorting, filter, format, name } = payload;

  yield call(statisticsService.exportMembersBySport, countryId, sorting, filter, format, name);
}


export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_DASHBOARD, dashboard),
    takeEvery(actions.FETCH_BASIC_MEMBERS_BY_SPORT, basicMembersBySport),
    takeEvery(actions.FETCH_BASIC_REGISTRATIONS_BY_PLACE, basicRegistrationsByPlace),
    takeEvery(actions.FETCH_BASIC_MEMBERS_WITHOUT_CONSENT_BY_PLACE, basicMembersWithoutConsentByPlace),
    takeEvery(actions.FETCH_REGISTRATION_PLACE, registrationsByPlace),
    takeEvery(actions.EXPORT_REGISTRATION_PLACE, exportRegistrationsByPlace),
    takeEvery(actions.FETCH_REGISTRATION_SPORT, registrationsBySport),
    takeEvery(actions.EXPORT_REGISTRATION_SPORT, exportRegistrationsBySport),
    takeEvery(actions.FETCH_MEMBER_PLACE, membersByPlace),
    takeEvery(actions.EXPORT_MEMBER_PLACE, exportMembersByPlace),
    takeEvery(actions.FETCH_MEMBER_SPORT, membersBySport),
    takeEvery(actions.EXPORT_MEMBER_SPORT, exportMembersBySport),
    takeEvery(actions.FETCH_REGISTRATION_SPORTS_BY_PLACE, registrationSportsByPlace),
  ])
}
